export const mapbox_key =
  "pk.eyJ1IjoicG9pc3NvbmNvbnN1bHRpbmciLCJhIjoiY2tjbDFsd3ZqMThuZzJxbWgyZm9qN2hkdiJ9.c8kle0V395V4ls9Z_UeIGg";

export const tileset_id = "mapbox://poissonconsulting.cgjwbycp";

export const source_layer = ["logged_simplify", "logged_dissolve"];

export const mapbox_style =
  "mapbox://styles/poissonconsulting/ckcwdrzs405ih1ipf7furwzm8";

export const tileset_base = "mapbox://poissonconsulting.0pagk9ut";

export const tileset_parks = "mapbox://poissonconsulting.76aj2bpw";

export const coordinates = [-132.6, 53.4];

export const bounds = [
  [-119.4, 50.2],
  [-119, 48.9],
];

export const year_min = 1965;

export const year_max = 2020;

export const base_colors = ["#ffff14", "#e45c31"];
